<div
  id="document-detail"
  data-e2e-id="document-detail"
  [preventWindowUnloading]="preventWindowUnloadingOptions"
>
  <app-global-header
    [header]="header"
    [theme]="headerTheme"
    [goBackRoute]="goBackRoute$ | async"
    [disableGlobalBanner]="true"
  >
    <right-slot>
      <div class="document-actions-wrapper">
        <app-document-actions
          [document]="document$ | async"
          [savingDocument]="savingDocument$ | async"
          [trackingScreenName]="trackingScreenName"
          [trackingObject]="documentTrackingObject$ | async"
          [saveAction]="documentSavedAction"
          [featureName]="featureName"
          [taxes]="taxes$ | async"
          [featureToggles]="featureToggles$ | async"
          [settings]="settings$ | async"
          [xeroAccount]="xeroAccount$ | async"
          (onDocumentAction)="documentAction($event)"
        >
        </app-document-actions>
      </div>
    </right-slot>
  </app-global-header>

  <ul class="document-detail-tabs-list">
    <li class="document-detail-tab" *ngFor="let tab of tabs">
      <i2g-router-link
        [label]="tab.label | translate"
        [route]="tab.route"
        [navigationExtras]="tab.navigationExtras"
        [e2eId]="tab.e2eId"
        alignment="center"
      >
      </i2g-router-link>
    </li>
  </ul>

  <app-global-banner></app-global-banner>

  <div class="router-outlet-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>

<app-confirm-dialog
  [dialogId]="confirmDialogId"
  [confirmTitle]="'DIALOG.UNSAVED_CHANGES.CONFIRM_TITLE' | translate"
  [confirmPrompt]="'DIALOG.UNSAVED_CHANGES.CONFIRM_PROMPT' | translate"
  [cancelText]="'ACTION.DISCARD' | translate"
  [yesText]="'ACTION.SAVE' | translate"
  [trackingObject]="documentTrackingObject$ | async"
  [primaryActionTapped]="documentSavedAction"
  (onClose)="onConfirmDialogClose.emit($event)"
>
</app-confirm-dialog>

<app-confirm-dialog
  *ngIf="documentType$ | async as documentType"
  [dialogId]="resendDocumentDialogId"
  [confirmTitle]="
    'DIALOG.RESEND_DOCUMENT.' + documentType + '.CONFIRM_TITLE'
      | uppercase
      | translate
  "
  [confirmPrompt]="
    'DIALOG.RESEND_DOCUMENT.' + documentType + '.CONFIRM_PROMPT'
      | uppercase
      | translate
  "
  [cancelText]="'ACTION.NO_THANKS' | translate"
  [yesText]="'ACTION.RESEND' | translate"
  [trackingObject]="documentTrackingObject$ | async"
  [primaryActionTapped]="resendPrimaryActionTapped"
  (onClose)="onResendDialogClose($event)"
>
</app-confirm-dialog>

<ng-container *ngIf="documentSettings$ | async as documentSettings">
  <app-shipping-info-dialog
    *ngIf="documentSettings.showShipping && enableShipping"
    [shipping]="documentShipping$ | async"
    [locale]="documentSettings.locale"
    [currencyCode]="documentSettings.currencyCode"
    [trackingScreenName]="trackingScreenName"
    (onUpdateShippingInfo)="updateDocumentContent($event)"
  >
  </app-shipping-info-dialog>
</ng-container>

<app-pdf-rerender-dialog
  [documentType]="documentType$ | async"
  [documentNumber]="documentNumber$ | async"
  [trackingScreenName]="trackingScreenName"
  (onReRenderPdf)="removeSignatures()"
>
</app-pdf-rerender-dialog>

<app-update-deposit-request-dialog
  *ngIf="enableDeposits"
  [trackingScreenName]="trackingScreenName"
  (onUpdateDepositRequest)="onUpdateDepositRequest()"
  (onCancelDepositRequest)="onCancelDepositRequest()"
>
</app-update-deposit-request-dialog>

<app-popup-blocked-dialog></app-popup-blocked-dialog>

<app-missing-client-email-dialog
  *ngIf="documentType$ | async as documentType"
  [trackingScreenName]="trackingScreenName"
  (onAddClientEmail)="onAddClientEmail(documentType)"
  (onDisableBankTransfer)="onDisableBankTransfer()"
>
</app-missing-client-email-dialog>
